module.exports = __webpack_public_path__ + "img/goodsC3.78f16bda.png";